<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">{{ $t('vincular-ocorrencia') }}</h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>

                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="ocorrenciasSelecionadas.length === 0"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-busca-agro-ass-cultura"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="ocorrencias"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="ocorrenciasSelecionadas"
                :custom-is-checked="
                    (selecionados, linha) =>
                        selecionados.idagro_ocorrencia === linha.idagro_ocorrencia
                "
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssOcorrenciaService from '@/services/agro/ocorrencia/AssOcorrenciaCulturaService';

// MENSAGENS
import Message from '@/models/Message';

export default {
    props: {
        idCultura: 0,
    },
    data() {
        return {
            service: new AssOcorrenciaService(this.$http, this.$router),
            ocorrencias: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'nomepopular', width: null, sortable: true, sortFn: null },
                { key: 'nomecientifico', width: null, sortable: true, sortFn: null },
                { key: 'tipo', width: null, sortable: true, sortFn: null },
            ],
            ocorrenciasSelecionadas: [],
            idagro_ocorrencia: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nomepopular',
            order: 'asc',
            msgs: [],
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.service
                .findNaoAssociados(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.idCultura,
                    this.abrev,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.ocorrencias = value;
                    this.isEmpty = this.ocorrencias.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    idtipocultura: this.idCultura,
                    idagro_ocorrencia: m.id,
                    codigo: m.idagro_ocorrenciaerp,
                    nomepopular: m.nomepopular,
                    nomecientifico: m.nomecientifico,
                    tipo: m.agroTipoOcorrencia.descricao,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.ocorrenciasSelecionadas.length > 0) {
                this.isLoading = true;

                this.service
                    .save(this.ocorrenciasSelecionadas, this.abrev)
                    .then((value) => {
                        if (value.content === null) {
                            this.msgs.push(new Message('error', `${value.message}`, true));
                        } else {
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-adicionar-associacao'
                            );
                            this.$emit('fecharModal', true);
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('alert', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('error', 'msg-selecione-ocorrencia', true));
                this.isLoading = false;
            }
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
